/* eslint-disable @typescript-eslint/no-empty-function */

import React from 'react';
import {ILayoutContext} from '../@interfaces/contexts/ILayoutContext';
import {DefaultLayoutState} from '../@types/components/layouts/DefaultLayout';
import app from '../helpers/app';
import {ISubscription} from '../@interfaces/services/Events/ISubscription';
import {IEvent} from '../@interfaces/services/Events';

const emptyObject = {};

export enum LayoutContextEvents {
    UPDATED = 'layout-context-events.updated',
}

export const LayoutContext = React.createContext<ILayoutContext>({
    flushPageTitleAndBreadcrumbs(): void {
    },

    onUpdate(listener: (event: IEvent, state: Partial<DefaultLayoutState>) => void): ISubscription {
        return app('events').listen(LayoutContextEvents.UPDATED, listener);
    },

    getPageMeta(): Partial<DefaultLayoutState> {
        return emptyObject;
    },

    setPageMeta(): void {
    },

    setPageTitle(): void {
    },

    setPageSubTitle(): void {
    },

    setPageBreadcrumbHome(): void {
    },

    setPageBreadcrumbItems(): void {
    },

    pushPageBreadcrumbItems(): void {
    },

    isLoadingIndicatorDisplayed(): boolean {
        return false;
    },

    showLoadingIndicator(): void {
    },

    hideLoadingIndicator(): void {
    }
});
